<template>
    <div class="jobs">
        <page-cover image-url="/images/jobs.jpg" title="Find Your Dream Job" description="We are absolutely committed to placing candidates into the best possible Early years roles with companies based on their interests." />
        <section>
            <div class="px-4 lg:px-12 md:container md:mx-auto py-12 lg:py-32">
                <div class="flex md:justify-between flex-wrap gap-y-12">
                    <h3 class="text-primary text-3xl font-semibold">Job Openings</h3>
                    <form>
                        <select v-model="selectedCategory" @change="onSelect(selectedCategory)" class="category">
                            <option disabled value="">Select a category</option>
                            <option v-for="(option, index) in jobCategories" :key="index" :value="option">{{ option }}</option>
                        </select>
                    </form>
                </div>
                <div class="mt-16 lg:mt-24">
                    <job v-for="(job, index) in filteredJobs" :key="index" :title="job.Title" :company="job.Company" :location="job.Location" :description="job.Description" :nav-to="job._path" />
                </div>
            </div>
        </section>
    </div>
</template>

<script setup>
import { ref } from 'vue';
const { data: latestJobs } = await useAsyncData('latestJobs', () => 
    queryContent('/jobs').where({ Active: true }).sort({ PublishDate: -1 }).find()
);
const jobCategories = [];
latestJobs.value.forEach(item => {
    const { Category } = item;
    if(!jobCategories.includes(Category)) {
        jobCategories.push(Category);
    };
});
const selectedCategory = ref('');
let filteredJobs = ref(latestJobs.value);
function onSelect(category) {
    if(category) {
        filteredJobs.value = latestJobs.value.filter(job => job.Category === category);
    }
}
useHead({
    title: 'Job Openings',
    link: [
        { rel: 'preload', as: 'image', href: '/images/jobs.jpg', fetchpriority: 'high' },
    ],
});
</script>

<style lang="scss" scoped>
.jobs {
    
}
</style>